'use client';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon, MinusIcon } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Checkbox = ({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) => {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer group size-4 shrink-0 cursor-pointer rounded-[4px] border border-veni-gray-500 bg-white shadow-xs transition-shadow outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-veni-green-800 data-[state=checked]:bg-veni-green-800 data-[state=checked]:text-white data-[state=indeterminate]:border-veni-green-800 data-[state=indeterminate]:bg-veni-green-800 data-[state=indeterminate]:text-white dark:bg-white dark:aria-invalid:ring-destructive/40 dark:data-[state=checked]:bg-veni-green-800',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <MinusIcon className="hidden size-3.5 group-data-[state=indeterminate]:inline-block" />
        <CheckIcon className="hidden size-3.5 group-data-[state=checked]:inline-block" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
};

export { Checkbox };
